<div class="dr-page">

  <!-- Hero Section -->
  <section class="dr-hero">
    <div class="dr-hero-glow"></div>
    <div class="dr-hero-content">
      <span class="dr-eyebrow"><i class="ti ti-download"></i> Sehyog Resource Library</span>
      <h1>Learning Resources</h1>
      <p>Download premium notes, mock tests, eBooks, templates, interview guides and much more.</p>

      <div class="dr-search-box">
        <i class="fa fa-search"></i>
        <input
          type="text"
          placeholder="Search resources..."
          [(ngModel)]="searchText"
          (input)="searchResources()">
      </div>

      <div class="dr-filter-buttons">
        <button
          [class.dr-active]="selectedFilter=='ALL'"
          (click)="changeFilter('ALL')">
          All
        </button>
        <button
          [class.dr-active]="selectedFilter=='FREE'"
          (click)="changeFilter('FREE')">
          Free
        </button>
        <button
          [class.dr-active]="selectedFilter=='PAID'"
          (click)="changeFilter('PAID')">
          Premium
        </button>
      </div>
    </div>
  </section>

  <!-- Loading -->
  <div class="dr-loading" *ngIf="loading">
    <span class="dr-spinner"></span>
    Loading resources...
  </div>

  <!-- Empty -->
  <div class="dr-empty" *ngIf="!loading && filteredResources.length==0">
    <span class="dr-empty-icon">🔍</span>
    <h3>No resources found</h3>
    <p>Try a different search term or switch filters.</p>
  </div>

  <!-- Cards -->
  <div class="dr-grid" *ngIf="!loading && filteredResources.length>0">
    <div class="dr-card" *ngFor="let item of filteredResources">

      <div class="dr-thumbnail">
        <img *ngIf="item.thumbnail" [src]="item.thumbnail" alt="{{item.name}}">
        <div class="dr-placeholder" *ngIf="!item.thumbnail">📚</div>
      </div>

      <div class="dr-card-body">
        <h3>{{item.name}}</h3>

        <div class="dr-price-row">
          <span class="dr-price dr-free" *ngIf="item.price==0">Free</span>
          <span class="dr-price" *ngIf="item.price>0">£{{item.price}}</span>
        </div>

        <p>{{item.title}}</p>
        <button class="dr-details-btn" (click)="openResource(item)">
          View Details <i class="ti ti-arrow-right"></i>
        </button>
      </div>

    </div>
  </div>

</div>